import { Injectable } from '@angular/core';
import { HostDomainsInterface, hostnamesData } from './hot-profiles-data';
import { Title } from '@angular/platform-browser';


@Injectable({providedIn: 'root'})


export class HostProfilePropertiesService {
    constructor(
        private title: Title
    ) { }

    
    /*** Properties */
    get hostProperties(): HostDomainsInterface {
        const host_domain = window.location.hostname
        return this.findProperties( host_domain)
    }



    findProperties(host: string): HostDomainsInterface {
        const hostDomain =  window.location.hostname
        // check if exist some configuration for this domain
        if (hostnamesData.some(domain => domain.domain == hostDomain)) {
            //
            return hostnamesData.filter(data => data.domain == hostDomain)[0]
        }
        else {
            return hostnamesData.filter(data => data.domain === 'default')[0]
        }

    }


      // Método para cambiar el favicon
  changeFavicon(icon?:string): void {
    const iconUrl = this.hostProperties.iconLogo
    const linkElement = document.querySelector("link[rel*='icon']") || this.createLinkElement();
    linkElement.setAttribute('href', iconUrl);
  }

    // Método privado para crear el elemento link si no existe
    private createLinkElement(): HTMLLinkElement {
        const link = document.createElement('link');
        link.setAttribute('rel', 'icon');
        document.head.appendChild(link);
        return link;
    }
        

    changeSplashLogo(){
        const iconUrl = this.hostProperties.iconLogo
        const linkElement = document.querySelector("link[rel*='icon']") || this.createLinkElement();
        linkElement.setAttribute('href', iconUrl);    }

    setTitle() {
        this.title.setTitle(this.hostProperties.tittle)
    }
    
    
}